import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopNomemberSmsSendingOrder(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="pop_sms_sending_order" popSize="s">
      <h2 className="pop_tit">비회원 문의 문자 전송 순서</h2>
      <div className="content_container scroll">
        <section className="com_board_search">
          <div className="com_bk_txt">*수신자 추가</div>
          <article className="search">
            <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
            <button className="com_btn gray ws s icon_search"></button>
          </article>
        </section>
        <table className="com_board_list">
          <colgroup>
            <col width="50px" />
            <col width="50px" />
            <col width="40%" />
            <col width="40%" />
          </colgroup>
          <thead>
            <tr>
              <th>
                <button className="btn_close_x"></button>
              </th>
              <th>순서</th>
              <th>수신자</th>
              <th>전화번호</th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 3, 4, 5].map((i, idx) => {
              return (
                <tr key={idx} className="btn_move">
                  <td>
                    <button className="btn_close_x"></button>
                  </td>
                  <td>{idx + 1}</td>
                  <td>
                    <button className="btn_link">김등록103</button>
                  </td>
                  <td>010-2134-2333</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopNomemberSmsSendingOrder;
